import { dataSchema } from './entities/constants';
import { getAction } from '../application/query';
function getEntityRenderProps(queryProps, data = dataSchema, isPreview = false) {
  const {
    getEntitySchema
  } = data;
  const {
    actions: {
      getAllPublished,
      getAll
    }
  } = getEntitySchema;
  const actionKey = isPreview ? getAll : getAllPublished || getAll;
  const action = getAction(actionKey, queryProps);
  return {
    actionKey,
    action
  };
}
export default getEntityRenderProps;
//# sourceMappingURL=get-entity-render-props.js.map